
// src/App.tsx
import React from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoginButton from "./components/LoginButton";
import LogoutButton from "./components/LogoutButton";
/*import Profile from "./components/Profile";
import UserForm from "./components/UserForm";
*/
import UserFormInput from "./components/UserFormInput"
import AutoLogin from "./components/AutoLogin";




const App: React.FC = () => {

  return (
    <div className="App"> 
      <div className="header-bar">
        <h2>REACT-MyApp</h2>
        <AuthenticatedTemplate><LogoutButton /></AuthenticatedTemplate>
        <UnauthenticatedTemplate><LoginButton /></UnauthenticatedTemplate>
      </div>

      <AuthenticatedTemplate>
          {/*<p>✅ You are signed in. <LogoutButton /></p> */}
          {/*<Profile />   {/* Protected content visible only when logged in */}
          <UserFormInput /> {/**/}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
          <p>❌ You are not signed in. </p>
         <AutoLogin /> {/**/}
      </UnauthenticatedTemplate>
      
    </div>
  );
};

export default App;
